"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReviewStatusChange = void 0;
const react_1 = require("react");
const products_table_constants_1 = require("../products-table.constants");
const useReviewStatusChange = ({ patchDisplayedRow, scheduleReviewStatusRefresh, }) => (0, react_1.useCallback)((change) => {
    scheduleReviewStatusRefresh(change);
    if (!change)
        return;
    void change.mutation.then((result) => {
        if (result) {
            patchDisplayedRow(change.productId, { [products_table_constants_1.REVIEWED_COLUMN_ID]: change.status });
        }
    });
}, [patchDisplayedRow, scheduleReviewStatusRefresh]);
exports.useReviewStatusChange = useReviewStatusChange;
